import { createMachine } from "xstate";
import { confirmMsisdnMigration } from "@nju/data-access-portal-msisdn";
import { IMobileFlow, IOfferMode } from "@nju/data-access-portal-offers";
import {
  IFSecureOrchestrator,
  IFtthOrchestrator,
  IMobileOrchestrator,
  IMultiOrderOrchestrator,
} from "@nju/data-access-portal-orchestrator";

interface IContext {
  orchestrator?:
    | IFtthOrchestrator
    | IMobileOrchestrator
    | IMultiOrderOrchestrator
    | IFSecureOrchestrator;
  mode: IOfferMode;
  flow: IMobileFlow;
}

type IEvent =
  | { type: "MIGRATION_CONFIRM" }
  | { type: "MIGRATION_CONFIRM_SUCCESS" }
  | { type: "MIGRATION_CONFIRM_ERROR" }
  | { type: "CANCEL_ORDER" }
  | { type: "ORDER_CANCEL_SUCCESS" }
  | { type: "CONFIRM_CANCEL_ORDER" }
  | { type: "ORDER_CANCEL_ERROR" };

export const orderCTABannerMachine = createMachine(
  {
    schema: {
      context: {} as IContext,
      events: {} as IEvent,
    },
    initial: "ready",
    states: {
      ready: {
        on: {
          MIGRATION_CONFIRM: {
            target: "migrate",
          },
          CANCEL_ORDER: {
            target: "cancelOrder",
          },
        },
      },
      migrate: {
        invoke: {
          src: "confirmMigration",
        },
        on: {
          MIGRATION_CONFIRM_SUCCESS: {
            target: "final",
          },
          MIGRATION_CONFIRM_ERROR: {
            target: "error",
          },
        },
      },
      cancelOrder: {
        invoke: {
          src: "cancelOrder",
        },
        on: {
          CONFIRM_CANCEL_ORDER: {
            actions: "redirectToSelectNewOrExistingNumberPage",
            target: "final",
          },
          ORDER_CANCEL_ERROR: {
            target: "error",
          },
        },
      },
      error: {
        type: "final",
      },
      final: {
        type: "final",
      },
    },
  },
  {
    services: {
      confirmMigration: ({ orchestrator }) => {
        return async (callback) => {
          if (!orchestrator?.id) {
            throw new Error("Missing orchestratorId");
          }

          try {
            await confirmMsisdnMigration({
              orchestratorId: orchestrator.id,
            });

            callback({ type: "MIGRATION_CONFIRM_SUCCESS" });
          } catch {
            callback({ type: "MIGRATION_CONFIRM_ERROR" });
          }
        };
      },
      cancelOrder: ({ orchestrator }) => {
        return async (callback) => {
          if (!orchestrator?.id) {
            throw new Error("Missing orchestrator.id");
          }
          return callback({ type: "CONFIRM_CANCEL_ORDER" });
        };
      },
    },
  },
);
